import React, { Component } from "react";

class Progress extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {percentage, hidden, ...rest} = this.props;

    let style = {};
    if(hidden===true) {
      style.display = 'none';
    }

    return <div className='progress' style={style}>
      <div
        className='progress-bar progress-bar-striped bg-success'
        role='progressbar'
        style={{ width: `${percentage}%` }}
      >
        {percentage}%
      </div>
    </div>;
  }

}

export default Progress;
